<div id="grupo_botones">
    <button *ngIf="!showInfo" pButton severity="info" type="button" icon="pi pi-info" class="p-button-info"
        (click)="infoMethodChild()"></button>
    <button *ngIf="checkRevisionButtons()" pButton severity="warning" type="button" icon="pi pi-pencil"
        class="p-button-warning" (click)="editMethodChild()"></button>
    <button *ngIf="checkRevisionButtons()" pButton severity="danger" type="button" icon="pi pi-trash"
        class="p-button-danger" (click)="deleteMethodChild()"></button>

    <button *ngIf="checkRevisionButtons() && showDuplicate" pButton severity="primary" type="button" icon="pi pi-copy"
        class="p-button-primary" (click)="duplicateMethodChild()"></button>
</div>